import {createLoggerMiddleware} from 'src/shared/logger/middleware';

export const logger = createLoggerMiddleware({
  component: 'XHS-PAGE-CHANNEL-LINEUP',
  page: 'channel-lineup',
});
